import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-dialog-popup',
  templateUrl: './dialog.component.html',
})
export class DialogComponent implements OnInit {
  @Input() header;
  @Input() body;
  @Input() dialogType;
  loading = true;

  constructor(protected ref: NbDialogRef<DialogComponent>) { }

  ngOnInit(): void {
    this.loading = false;
  }

  proceed(value) {
    this.ref.close({ value: value });
  }

}
